import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import * as mock from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const defaultContent = {
  settings: {
    tagline: mock.site.tagline,
    bookUrl: mock.site.bookUrl,
    servicesUrl: mock.site.servicesUrl,
    instagram: mock.site.instagram,
    hero: mock.hero,
    about: mock.about,
    contact: { phone: mock.contact.phone, email: mock.contact.email },
    hours: mock.contact.hours,
    locationsBanner: mock.site.locations,
  },
  pricing: mock.pricing,
  team: mock.team,
  locations: mock.locations,
  promotions: [],
};

const ContentContext = createContext({
  content: defaultContent,
  loading: true,
  refresh: () => {},
});

export function ContentProvider({ children }) {
  const [content, setContent] = useState(defaultContent);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const res = await axios.get(`${API}/content`);
      const d = res.data || {};
      setContent({
        settings: { ...defaultContent.settings, ...(d.settings || {}) },
        pricing: d.pricing && d.pricing.length ? d.pricing : defaultContent.pricing,
        team: d.team && d.team.length ? d.team : defaultContent.team,
        locations: d.locations && d.locations.length ? d.locations : defaultContent.locations,
        promotions: d.promotions || [],
      });
    } catch (e) {
      // keep defaults on failure
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
